/* Performs matching against an application route to return a default menbu for a page

   Pass it a structure like this:

       const menuRoutes = [
        { match: 'domains' , defaultMenu: 'domains', default: true},
        { match: 'dashboard' , defaultMenu: 'dashboard'},
        { match: 'organisations' , defaultMenu: 'organisations'},
    ]

 */
export const getDefaultMenuForPath = ( path, routes ) =>
{
    const final = routes.reduce((current, obj) => {
        if ( path.includes(obj.match) || ( current === null && obj.default === true))
        {
            return obj.defaultMenu ;
        }
        else
        {
            return current ;
        }
    }, null);

    return final ;
}